export default function createEvent(name) {
    if (typeof Event === 'function') {
        return new Event(name, {bubbles: true});
    } else {
        let event = document.createEvent("Event");
        event.initEvent(name, true, true);
        return event;
    }
};



// WEBPACK FOOTER //
// ./app/general/js/create-event.js